/** @module SiteAdmin/Locale */
define([
    "csi/siteDefaultLocale"
], function(siteDefaultLocale) {
	return siteDefaultLocale;
});
